/* schmorzeit-sale.js: rechnet die Sale-Hinweise mit dem Warenkorb.
   Produktkarten ("Damit 10 % auf alles"), Box auf der Produktseite
   (Warenkorb plus dieser Artikel), Leiste ueber Kollektionen (erreichte
   Stufe). Nach Ablauf entfernt es alle Hinweise, auch wenn eine
   zwischengespeicherte Seite sie noch enthaelt.
   Konfiguration: snippets/schmorzeit-sale-assets.liquid. Vanilla, kein Build. */
(function () {
  'use strict';
  var el = document.getElementById('sz-sale-config');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  var ENDE = Date.parse(cfg.ende);
  var STUFEN = cfg.stufen || [];
  var NB = ' ';

  function vorbei() { return ENDE && Date.now() > ENDE; }
  function wegraeumen() {
    document.querySelectorAll('[data-sz-sale-weg]').forEach(function (n) { n.remove(); });
  }
  function euro(c) { return (Math.round(c) / 100).toFixed(2).replace('.', ',') + NB + '€'; }
  function rabatt(w) { var p = 0; STUFEN.forEach(function (s) { if (w >= s[0]) p = s[1]; }); return p; }
  function naechste(w) { for (var i = 0; i < STUFEN.length; i++) if (w < STUFEN[i][0]) return STUFEN[i]; return null; }

  // Warenwert wie beim Rabatt: vor Warenkorb-Rabatten, ohne Gutscheine
  var korb = 0;
  function warenwert(cart) {
    var w = cart.items_subtotal_price || 0;
    (cart.items || []).forEach(function (it) { if (it.gift_card) w -= it.final_line_price; });
    return Math.max(0, w);
  }

  function karten() {
    document.querySelectorAll('[data-sz-sale-karte]').forEach(function (p) {
      var preis = Number(p.getAttribute('data-preis')) || 0;
      var mit = korb + preis;
      var t;
      if (korb === 0) t = rabatt(preis) ? 'Allein schon ' + rabatt(preis) + NB + '% auf alles' : 'Ab 89' + NB + '€ Warenkorb 5' + NB + '% auf alles';
      else if (rabatt(mit) > rabatt(korb)) t = 'Damit ' + rabatt(mit) + NB + '% auf alles';
      else if (rabatt(korb) > 0) t = rabatt(korb) + NB + '% auf alles aktiv';
      else t = 'Damit noch ' + euro(STUFEN[0][0] - mit) + ' bis 5' + NB + '%';
      if (p.textContent !== t) p.textContent = t;
    });
  }

  function leisten() {
    document.querySelectorAll('[data-sz-sale-leiste]').forEach(function (l) {
      l.querySelectorAll('[data-ab]').forEach(function (c) { c.classList.toggle('is-an', korb >= Number(c.getAttribute('data-ab'))); });
    });
  }

  // Produktseite: gewaehlte Variante und Menge aus dem Hauptformular
  function pdpAuswahl(box) {
    var form = document.querySelector('form.js-product-form-main');
    var id = form && form.querySelector('[name="id"]');
    var menge = form && (document.querySelector('[name="quantity"][form="' + form.id + '"]') || form.querySelector('[name="quantity"]'));
    var preise = {};
    try { preise = JSON.parse(box.getAttribute('data-preise') || '{}'); } catch (e) {}
    var vid = (id && id.value) || box.getAttribute('data-variante');
    var preis = preise[vid] || 0;
    var n = Math.max(1, parseInt(menge && menge.value, 10) || 1);
    return preis * n;
  }

  function pdp() {
    document.querySelectorAll('[data-sz-sale-pdp]').forEach(function (box) {
      var artikel = pdpAuswahl(box);
      if (!artikel) return;
      var mit = korb + artikel;
      var pct = rabatt(mit);
      var nx = naechste(mit);
      box.querySelectorAll('[data-ab]').forEach(function (s) { s.classList.toggle('is-an', mit >= Number(s.getAttribute('data-ab'))); });
      var fill = box.querySelector('[data-sz-sale-fill]');
      // Abschnittsweise, passend zu den drei gleich breiten Stufen-Kacheln
      if (fill) fill.style.width = balken(mit) + '%';
      var satz = 'Mit diesem Artikel kommst du auf <b>' + euro(mit) + '</b>' + (pct ? ' und bekommst <b>' + pct + NB + '% auf alles</b>.' : '.');
      if (nx) satz += ' Noch <b>' + euro(nx[0] - mit) + '</b> bis ' + nx[1] + NB + '%.';
      else satz += ' Höchste Stufe erreicht.';
      var p = box.querySelector('[data-sz-sale-satz]');
      if (p && p.innerHTML !== satz) p.innerHTML = satz;
    });
  }

  function balken(w) {
    var vorher = 0;
    for (var i = 0; i < STUFEN.length; i++) {
      var ab = STUFEN[i][0];
      if (w < ab) return (i + (w - vorher) / (ab - vorher)) / STUFEN.length * 100;
      vorher = ab;
    }
    return 100;
  }

  function zeichnen() { karten(); leisten(); pdp(); }

  var origFetch = window.fetch.bind(window);
  function laden() {
    if (vorbei()) { wegraeumen(); return; }
    origFetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { korb = warenwert(cart); zeichnen(); })
      .catch(function () { zeichnen(); });
  }

  var uhr = null;
  function bald() { clearTimeout(uhr); uhr = setTimeout(laden, 400); }

  // Warenkorb-Aenderungen (Theme, Apps, Gratis-Dosen) loesen ein Nachrechnen aus
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var vorher = window.fetch;
  window.fetch = function (input, init) {
    var p = vorher.apply(this, arguments);
    var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
    if (CART_RE.test(String(url))) p.then(bald, function () {});
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART_RE.test(String(url))) this.addEventListener('loadend', bald);
    return xOpen.apply(this, arguments);
  };
  document.addEventListener('sz:zugabe', bald);

  // Produktseite: Variante oder Menge geaendert
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'id' || e.target.name === 'quantity' || e.target.closest('variant-picker, .variant-picker, .product-options'))) setTimeout(pdp, 50);
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'quantity') setTimeout(pdp, 50);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.qty-input__btn, variant-picker, .variant-picker')) setTimeout(pdp, 80);
  }, true);
  function beobachten() {
    var form = document.querySelector('form.js-product-form-main');
    var id = form && form.querySelector('[name="id"]');
    if (id && 'MutationObserver' in window) new MutationObserver(function () { pdp(); }).observe(id, { attributes: true, attributeFilter: ['value'] });
  }

  function start() { beobachten(); laden(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) laden(); });
  // Nachgeladene Karten (Filter, Seitenwechsel, "Mehr laden"). Nur auf Seiten
  // mit Produktkarten und nur im Hauptbereich beobachten.
  var bereich = document.querySelector('main') || document.body;
  if ('MutationObserver' in window && document.querySelector('[data-sz-sale-karte], [data-sz-sale-leiste]')) {
    var neueKarten = null;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('[data-sz-sale-karte], [data-sz-sale-pdp]') || n.querySelector('[data-sz-sale-karte], [data-sz-sale-pdp]'))) {
            clearTimeout(neueKarten); neueKarten = setTimeout(function () { if (vorbei()) wegraeumen(); else zeichnen(); }, 60);
            return;
          }
        }
      }
    }).observe(bereich, { childList: true, subtree: true });
  }
})();
